var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwiftttLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 899.95 170.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n            fill: #1a1a1a;\r\n            stroke-width: 0px;\r\n            }\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.34,96.9l14.04-28.52h0S82.94.19,82.94.19h-33.56C22.11.19,0,22.3,0,49.57c0,22.39,14.91,41.27,35.34,47.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m130.52,73.84l-47.6,96.71h33.56c27.27,0,49.38-22.11,49.38-49.38,0-22.39-14.91-41.27-35.34-47.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.53,
    y: 106.48,
    width: 67.88,
    height: 64.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.46 64.26 136.66 64.26 168.49 0 90.46 .19 90.46 64.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m334.86,88.95c-2.18-2.45-4.57-4.52-7.19-6.19-2.62-1.67-5.24-3.04-7.86-4.1-2.62-1.06-5.1-1.9-7.44-2.51-2.34-.61-4.24-1.09-5.69-1.42-7.47-1.9-13.53-3.48-18.15-4.77-4.63-1.28-8.26-2.51-10.88-3.68-2.62-1.17-4.38-2.48-5.27-3.93-.89-1.45-1.34-3.35-1.34-5.69s.56-4.54,1.67-6.27c1.11-1.73,2.54-3.15,4.27-4.27,1.73-1.11,3.65-1.9,5.77-2.34,2.12-.44,4.24-.67,6.36-.67,3.12,0,6.08.28,8.87.84,2.79.56,5.24,1.51,7.36,2.84,2.12,1.34,3.82,3.18,5.1,5.52,1.28,2.34,2.03,5.3,2.26,8.87h25.43c0-6.91-1.31-12.8-3.93-17.65-2.62-4.85-6.16-8.84-10.62-11.96-4.46-3.12-9.56-5.38-15.31-6.78-5.75-1.39-11.74-2.09-17.98-2.09-5.35,0-10.71.73-16.06,2.17-5.35,1.45-10.15,3.68-14.39,6.69-4.24,3.01-7.67,6.78-10.29,11.29-2.62,4.52-3.93,9.84-3.93,15.98,0,5.58,1.03,10.26,3.1,14.05,2.06,3.79,4.77,6.97,8.11,9.54,3.35,2.57,7.14,4.66,11.38,6.27,4.24,1.62,8.59,2.99,13.05,4.1,4.35,1.23,8.64,2.32,12.88,3.26,4.24.95,8.03,2.12,11.38,3.51,3.35,1.4,6.05,3.1,8.11,5.1,2.06,2.01,3.1,4.63,3.1,7.86,0,3.01-.78,5.49-2.34,7.44-1.56,1.95-3.51,3.49-5.86,4.6-2.34,1.12-4.85,1.87-7.53,2.26-2.68.39-5.19.59-7.53.59-3.57,0-6.94-.42-10.12-1.26-3.18-.84-5.97-2.12-8.36-3.85-2.4-1.73-4.32-3.99-5.77-6.78-1.45-2.79-2.18-6.19-2.18-10.21h-25.43c-.11,7.36,1.26,13.72,4.1,19.07,2.84,5.35,6.61,9.76,11.29,13.22,4.69,3.46,10.12,6.02,16.31,7.7,6.19,1.67,12.57,2.51,19.16,2.51,8.14,0,15.31-.98,21.5-2.93,6.19-1.95,11.38-4.63,15.56-8.03,4.18-3.4,7.33-7.44,9.45-12.13,2.12-4.68,3.18-9.76,3.18-15.23,0-4.46-.67-8.39-2.01-11.79-1.34-3.4-3.1-6.33-5.27-8.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "458.25 107.86 457.92 107.86 437.5 25.55 412.91 25.55 392.16 106.86 391.83 106.86 372.92 25.55 346.66 25.55 378.28 145 404.88 145 424.79 63.69 425.12 63.69 445.37 145 471.47 145 503.59 25.55 477.83 25.55 458.25 107.86"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 515.63,
    y: 25.55,
    width: 26.27,
    height: 119.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560.77,
    y: 129.91,
    width: 26.27,
    height: 15.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "587.04 95.65 637.07 95.65 637.07 89.06 560.77 89.06 560.77 102.11 587.04 102.11 587.04 95.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "637.07 75.24 587.04 75.24 587.04 68.64 560.77 68.64 560.77 81.69 637.07 81.69 637.07 75.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 560.77,
    y: 109.48,
    width: 26.27,
    height: 13.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 668.58,
    y: 109.48,
    width: 26.27,
    height: 13.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 668.58,
    y: 129.91,
    width: 26.27,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 668.58,
    y: 68.64,
    width: 26.27,
    height: 13.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 668.58,
    y: 89.06,
    width: 26.27,
    height: 13.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 748.64,
    y: 130.91,
    width: 24.27,
    height: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m771.91,131.91v11.1h-22.27v-11.1h22.27m2-2h-26.27v15.1h26.27v-15.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 748.64,
    y: 69.63,
    width: 24.27,
    height: 11.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m771.91,70.64v9.05h-22.27v-9.05h22.27m2-2h-26.27v13.05h26.27v-13.05h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 748.64,
    y: 90.06,
    width: 24.27,
    height: 11.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m771.91,91.06v9.05h-22.27v-9.05h22.27m2-2h-26.27v13.05h26.27v-13.05h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 748.64,
    y: 110.48,
    width: 24.27,
    height: 11.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m771.91,111.48v9.05h-22.27v-9.05h22.27m2-2h-26.27v13.05h26.27v-13.05h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 826.7,
    y: 129.91,
    width: 26.27,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 826.7,
    y: 68.64,
    width: 26.27,
    height: 13.05
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "560.77 25.55 560.77 61.27 587.04 61.27 587.04 47.63 668.58 47.63 668.58 61.27 694.84 61.27 694.84 47.63 747.64 47.63 747.64 61.27 773.91 61.27 773.91 47.63 826.7 47.63 826.7 61.27 852.97 61.27 852.97 47.63 888.77 47.63 899.95 25.55 560.77 25.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 826.7,
    y: 109.48,
    width: 26.27,
    height: 13.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 826.7,
    y: 89.06,
    width: 26.27,
    height: 13.05
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftttLogo);
export default __webpack_public_path__ + "static/media/SwiftttLogo.abe41687823dd703511c140a4c09c8d3.svg";
export { ForwardRef as ReactComponent };